<template>
<div :ref="loadingobj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">新增分类</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="list.length > 1 ? list.length : ''" class="item">
        <wcbutton :option="{title:'提交数据'}" @finish="submitData"/>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'清空已填模板',type:'del'}" @finish="Dellist(-1)"/>
        </div>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'新增分类模板',type:'del'}" @finish="AddModelInfo"/>
        </div>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'返回分类管理',type:'del'}" @finish="$parent.JUMPVIEW({name:'EsCates'})"/>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in list" :key="index">
            <div class="TTL-form-submit-box-title">分类-{{index+1}}</div>
            <div class="TTL-button TTL-btn-option">
            <el-button type="del" v-if="list.length > 1" @click.stop="Dellist(index)">删除</el-button>
            </div>
            <el-form :inline="false" style="margin-top:20px">
                <el-form-item>
                    <wcupload :option="{size:'large'}" 
                        :value="item.thumb" 
                        @finish="(val)=> {
                            item.thumb=val.url;
                            SaveDataToBrowser();
                        }" 
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">分类名称<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入分类名称',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.name"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.name=val.value;
                                SaveDataToBrowser();
                            }
                            if(val.type=='change') {
                                item.name=val.value;
                                SaveDataToBrowser();
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">一级分类</label>
                    <wcselect :option="{placeholder:'请选择一级分类',filterable:true,clearable:true,ischange:true,width:'250px'}" 
                        :value="item.pid" 
                        :list="catelists"
                        @finish="(val)=> {
                            if(val.type=='change') {
                                item.pid=val.value;
                                item.pname=val.valuename;
                                SaveDataToBrowser();
                            }
                        }"
                    />
                </el-form-item>

            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_CATE from '@/Interface/Es/Goods/Cates';
export default {
    components:{},
    data() {
        return {
            Browser:'addcate',
            loadingobj:'addcate',
            limit:10,  //限制添加数据条数
            cateinfo:{thumb:'',name:'',pid:'',pname:''}, //品牌信息               
            list:[], //数据
            catelists:[], //一级分类信息
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.ParseData();  //解析之前填写的数据
            this.GetParentCates(isfresh); //获取一级分类信息列表
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                
            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }
        },


        /** 保存模板信息 **/
        submitData() {
            if(this.list.length==0) {this.$notice({title:'错误提示',message:'请至少填写一个品牌',type:'warning'});return false;}
            var data=[];
            for(var i in this.list) data.push(this.list[i]);
            data=JSON.stringify(data);

            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_CATE.ADD_CATES({data:data}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.ResetParam(); //重置数据
                this.$notice({title:'成功提示',message:'添加数据成功',type:'success'});
            });
        },


        //////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////
        //基础数据操作


        /** 获取品牌信息列表 **/
        GetParentCates(isfresh) {
            this.$method.GET_CATES_PARENT(isfresh).then((res) => {this.catelists=res;console.log(res)});
        },


        /** 新增模板信息 **/
        AddModelInfo() {
            if(this.list.length >= this.limit) {this.$notice({title:'错误提示',message:'新增模板数量不能超过'+this.limit+'个',type:'warning'});return false;}
            var dateinfo={};
            for(var i in this.cateinfo) dateinfo[i]=this.cateinfo[i];
            this.list.push(dateinfo);
            this.SaveDataToBrowser();
        },


        /** 删除模板信息 **/
        Dellist(index) {

            //删除单个模板信息时，无需询问，直接删除
            if(index >=0) {
                this.list.splice(index,1);
                this.SaveDataToBrowser();
                return false;
            } 

            //删除全部模板时先询问再操作
            this.$confirm.confirm(
                '您是否确定要删除当前所有模板文件信息 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                this.ResetParam();
            }).catch(()=> {

            });
        },   


        /** 数据重置 **/
        ResetParam() {
             this.list=[];
             this.AddModelInfo();
        },


        /** 缓存数据到浏览器 **/
        SaveDataToBrowser() {
            this.$LOCALDATA.SetBrowData(this.Browser,this.list);
        },


        /** 从浏览器提取数据解析 **/
        ParseData() {
            this.list=this.$LOCALDATA.GetBrowData(this.Browser);
        },


    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:100px;height:100px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
::v-deep(.imagefile .el-image__inner) {width:50% !important;height: 50% !important;}

.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.petTitle {padding:30px 0 20px 0;}
.TTL-photos {display:inline-block;width:100%;font-size:0;}
.TTL-photos-infos {display:inline-block;width:100px;height:100px;margin-right:10px;margin-bottom:10px;background-color:#e6e7ec;border-radius: 15px;overflow:hidden;position:relative;}
.TTL-photos-infos .el-image {width:100%;height:100%;}
.TTL-photos-del {width:25px;height:25px;position: absolute;top:0;right:0;margin-top:5px;margin-right:5px;border-radius: 50%;background-color: rgba(0,0,0,1);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/close.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.default-photos {background-image:url(@/assets/icon/default-img.png);background-repeat: no-repeat;background-size: 65%;background-position: center;cursor: pointer;}
.TTL-photos-select {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:#666eeb;display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-photos-select-no {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:rgba(221,221,221,.6);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-form-label i {font-style:normal;color:red;font-size:12px;font-weight: 400;}
.fileup {background-color: #666eeb !important;}
::v-deep(.fileup .el-image__inner) {width:80% !important;height: 80% !important;}
</style>